import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">{aboutData.title}</h2>

          <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-5 bg-background-100 rounded-lg">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                <div className="mt-1 text-xs text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}